import { Action, configureStore, ThunkAction } from "@reduxjs/toolkit";
import firebaseAuthSlice from "./authSlice";
import providerDetailsSlice from "./providerDetailsSlice";
import singleHealthFacilityDetailsSlice from "./singleHealthFacilitySlice";
import superAdminProvidersSlice from "./superAdminProvidersSlice";
import formOptionsSlice from "./formOptionsSlice";
import fileUploadReducer from "./fileUploadSlice";
import allProvidersReducer from "./allProvidersSlice";

export function createAuthStore() {
  return configureStore({
    reducer: {
      firebaseAuthentication: firebaseAuthSlice,
      providerDetails: providerDetailsSlice,
      singleHealthFacilityDetails: singleHealthFacilityDetailsSlice,
      superAdminProviders: superAdminProvidersSlice,
      formOptions: formOptionsSlice,
      fileUpload: fileUploadReducer,
      allProviders: allProvidersReducer,
    },
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({
        serializableCheck: false,
      }),
  });
}

type AuthStore = ReturnType<typeof createAuthStore>;
export type AuthAppDispatch = AuthStore["dispatch"];
export type AuthRootState = ReturnType<AuthStore["getState"]>;
export type AuthAppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  AuthRootState,
  unknown,
  Action<string>
>;
